import { QueryCache, QueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

function toMessage(error: unknown): string {
  if (typeof error === 'object' && error !== null && 'response' in error) {
    const data = (error as { response?: { data?: { error?: unknown; message?: unknown } } }).response?.data
    if (typeof data?.error === 'string' && data.error) return data.error
    if (typeof data?.message === 'string' && data.message) return data.message
  }
  if (error instanceof Error && error.message) return error.message
  return 'Request failed. Please try again.'
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      toast.error(toMessage(error))
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response?.status
        if (status === 401 || status === 403 || status === 404) return false
        return failureCount < 1
      },
    },
  },
})
